import apiCall from "../utils/apiCall";
import { dynamicSort, clearAPICache } from "../utils/utilityFunctions";

export default class PartyService {
  static listParty = async () => {
    // let response = await apiCall(`/api/Parties/Get`);
    let response = await apiCall(`/api/Parties/get/v2`, "GET", null, null, null, true);

    // if (response?.Data) {
    //   response?.Data.sort(dynamicSort("PartyName"));
    // }

    return response?.Data;
  };

  static listPartyPaginated = async (
    currentPage = 1,
    PageSize = 10,
    query = "",
    contactQuery = "",
    country = "",
    contactRole = "",
    orderByAsc
  ) => {
    return await apiCall(
      `/api/Parties/List?pageCount=${currentPage}&noPerPage=${PageSize}&searchParam=${query}&orderByAsc=${orderByAsc}&cSearchParam=${contactQuery}&contactRole=${contactRole}&country=${country}`
    );
  };

  static CountParties = async () => {
    return await apiCall(`/api/Parties/CountParties`);
  };

  static getPartyWithContactPerson = async (partyId) => {
    return await apiCall(`/api/Parties/GetExtended/${partyId}`);
  };

  static postParty = async (payload) => {
    clearAPICache(`/api/Parties/get/v2`);
    return await apiCall(`/api/Parties/Post`, "POST", payload);
  };

  static listPartyTypes = async () => {
    const response = await apiCall(`/api/PartyTypes`, "GET", null, null, null, true);
    return response?.Data;
  };

  static postVesselParties = async (
    partyTypeId,
    partyId,
    vesselSpecificationId
  ) => {
    clearAPICache(`/api/PartyVessel/Get`);
    const payload = { partyTypeId, partyId, vesselSpecificationId };
    return await apiCall(`/api/PartyVessel/Post`, "POST", payload);
  };

  static getVesselParties = async () => {
    return await apiCall(`/api/PartyVessel/Get`, "GET", null, null, null, true);
  };

  static listByVesselId = async (vesselSpecificationId) => {
    return await apiCall(`/api/parties/listforvessel/${vesselSpecificationId}`);
  };

  static contactPersonList = async () => {
    return await apiCall(`/api/ContactPerson/Get`, "GET", null, null, null, true);
  };

  static contactPersonRole = async () => {
    return await apiCall(`/api/ContactPersonRole/Get`, "GET", null, null, null, true);
  };

  static partyRoles = async () => {
    return await apiCall(`api/Roles`, "GET", null, null, null, true);
  };
  static postEditedParty = async (id, payload) => {
    clearAPICache(`/api/Parties/get/v2`);
    return await apiCall(`api/parties/Put/${id}`, "PUT", payload);
    //http://parties/Put/
  };

  static updatePartyVessel = async (id, payload, newPartyId) => {
    payload.partyId = newPartyId;
    clearAPICache(`/api/PartyVessel/Get`);
    return await apiCall(`api/partyVessel/Put/${id}`, "PUT", payload);
  };

  static getPartyVessels = async (partyId) => {
    let response = await apiCall(
      `/api/parties/GetPartyVessels?partyId=${partyId}`
    );
    if (response) {
      response = response.map((e) => ({ ...e.specification, ...e }));
    }
    return response;
  };
}
